/* eslint-disable */
export default {
  _button_click: 'button_click',
  _color: 'color',
  _jingle: 'jingle',
  _keychain: 'keychain',
  _patches: 'patches',
  _SchoolBell: 'SchoolBell',
  _Zipper_Close: 'Zipper_Close',
  _Zipper_Open: 'Zipper_Open',
}